let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZDP3")).then(() => parcelRequire('4NTOP'));